import regExp from './regExp'
import { vaildIdCard } from './tools'
import { regAPI } from '@/api'
const sucCode = ['200000']
// 校验是否是正整数
export const isPositiveInteger= (rule, value, callback) => {
    if (!value) {
        return callback()
    }
    if (!regExp.positiveInteger.test(value)) {
        callback(new Error('请输入正整数'))
    } else {
        callback()
    }
}
// 校验手机号
export const isPhone = (rule, value, callback) => {
    if (!value) {
        return callback()
    }
    if (!regExp.phone.test(value)) {
        callback(new Error('请输入正确手机号'))
    } else {
        callback()
    }
}
// 判断手机号是否存在
export const hasPhone = (rule, value, callback) => {
    if (!value) {
        return callback()
    }
    regAPI.verfiyHas({
        ph: value,
        action: 'phone'
    }).then(res => {
        if(!sucCode.includes(res.code)){
            callback(new Error(res.msg))
        } else {
            callback()
        }
    })
}
// 校验邮箱
export const isEamil = (rule, value, callback) => {
    if (!value) {
        return callback()
    }
    if (!regExp.email.test(value)) {
        callback(new Error('请输入正确邮箱'))
    } else {
        callback()
    }
}
// 判断邮箱是否存在
export const hasEmail =  (rule, value, callback) => {
    if (!value) {
        return callback()
    }
    regAPI.verfiyHas({
        email: value,
        action: 'email'
    }).then(res => {
        if(!sucCode.includes(res.code)){
            callback(new Error(res.msg))
        } else {
            callback()
        }
    })
}
// 验证身份证
export const isIdCard = (rule, value, callback) => {
    if (!value) {
        return callback()
    }
    let data = vaildIdCard(value)
   
    if (data.code === 1) {
        callback(new Error(data.message || '请输入正确身份证'))
    } else {
        console.log(data, '身份证成功')
        callback()
    }
}
// 判断身份证是否存在
export const hasIdCard = (rule, value, callback) => {
    if (!value) {
        return callback()
    }
    regAPI.verfiyHas({
        idcard: value,
        action: 'IsExist'
    }).then((res) => {
        if(!sucCode.includes(res.code)){
            return callback(new Error(res.msg))
         } else {
            return  callback()
         } 
    })
}
// 判断身份证永不录用  
export const hasIdCardAdmission =  (rule, value, callback) => {
    if (!value) {
        return callback()
    }
   regAPI.verfiyHas({
        idcard: value,
        action: 'IsRefused'
    }).then((res) => {
        if(!sucCode.includes(res.code)){
            return callback(new Error(res.msg))
         } else {
            return  callback()
         }
    })
    
}
// 验证最少输入多长
export const minLength = (rule, value, callback) => {
   
    if (!value) {
        return callback()
    }
    if (rule.min && value.length < rule.min) {
        callback(new Error(`${rule.msg}最少输入${rule.min}个字符`))
    } else {
        callback()
    }
}